import React from "react";
import { IAboutHistoryData } from "../../exports/interfaces";

export const History = (props: { aboutHistory: IAboutHistoryData[] }) => {
  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          {/* <p className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color">
            WELCOME
          </p> */}
          <h2 className="td_section_title td_fs_48 mb-0">
            History of University of Nepal
          </h2>
          <div className="td_height_30 td_height_lg_30" />
        </div>
        <div className="row td_gap_y_50">
          <p
            className="mb-0 td_fs_18"
            dangerouslySetInnerHTML={{
              __html: props?.aboutHistory[0]?.description,
            }}
          />
        </div>
      </div>

      <div className="td_tab" id="td_tab_3">
        <p className="mb-0"></p>
      </div>

      <div className="td_height_120 td_height_lg_40" />
    </section>
  );
};
